import {
  SET_INVENTORIES,
  SET_TOLERANCES,
  SET_CATEGORIES,
  SET_PRODUCTS,
  SET_BRANDS,
} from '../types/inventory'
import {
  fetchInventoriesAPI,
  getWeightTolerancesAPI,
  updateWeightTolerancesAPI,
  deleteInventoryAPI,
  addNewInventoryAPI,
  updateInventoryAPI,
  getCategoriesAPI,
  getCategoryByIdAPI,
  loadProductsAPI,
  loadBrandsAPI,
  bulkupdateProductsAPI,
  loadProductsByIdAPI,
  getProductSellAPI,
  getProductAPI,
} from '../api/inventory'
import { addMessageCurry, commonActionAPIHit } from '../utils/api'

export const setInventories = (payload) => ({
  type: SET_INVENTORIES,
  payload: payload,
})

export const setTolerances = (payload) => ({
  type: SET_TOLERANCES,
  payload: payload,
})

export const setCategories = (payload) => ({
  type: SET_CATEGORIES,
  payload,
})

export const setProducts = (payload) => ({
  type: SET_PRODUCTS,
  payload,
})

export const setBrands = (payload) => ({
  type: SET_BRANDS,
  payload,
})

export const fetchInventories = (shopId) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      const data = { shopId }

      addMessageCurry(fetchInventoriesAPI(data), dispatch).then((inventories) => {
        resolve(inventories)
        dispatch(setInventories(inventories))
      })
    })
  }
}

export const deleteInventory = commonActionAPIHit(deleteInventoryAPI)
export const addNewInventory = commonActionAPIHit(addNewInventoryAPI)
export const updateInventory = commonActionAPIHit(updateInventoryAPI)

export const getTolerances = () => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      addMessageCurry(getWeightTolerancesAPI(), dispatch).then((tolerances) => {
        resolve(tolerances)
        dispatch(setTolerances({ tolerances }))
      })
    })
  }
}

export const updateTolerance = (tolerance) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      addMessageCurry(updateWeightTolerancesAPI(tolerance), dispatch).then((tolerance) => {
        resolve(tolerance)
      })
    })
  }
}

export const getCategories = () => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      addMessageCurry(getCategoriesAPI(), dispatch).then((categories) => {
        resolve(categories)
        dispatch(setCategories({ categories }))
      })
    })
  }
}

export const getCategoryById = (id) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      addMessageCurry(getCategoryByIdAPI(id), dispatch).then((category) => {
        resolve(category)
      })
    })
  }
}

export const loadProducts = (filters) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      addMessageCurry(loadProductsAPI(filters), dispatch).then((products) => {
        resolve(products)
        dispatch(setProducts({ products }))
      })
    })
  }
}

export const loadBrands = (filters) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      addMessageCurry(loadBrandsAPI(filters), dispatch).then((brands) => {
        resolve(brands)
        dispatch(setBrands({ brands }))
      })
    })
  }
}

export const bulkupdateProducts = (payload) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      bulkupdateProductsAPI(payload).then((res) => resolve(res))
    })
  }
}

export const loadProductsById = (masterId) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      const dataProd = { masterId }
      addMessageCurry(loadProductsByIdAPI(dataProd), dispatch).then((products) => {
        //console.log("productsAction",products);
        dispatch(setProducts({ products }))
        resolve(products)
      })
    })
  }
}

export const getProductSell = (productId) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      addMessageCurry(getProductSellAPI(productId), dispatch).then((product) => {
        resolve(product)
      })
    })
  }
}

export const getProduct = (productId) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      addMessageCurry(getProductAPI(productId), dispatch).then((product) => {
        resolve(product)
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/actions/inventory.js